'use client';

import { Global } from '@emotion/react';
import { useTranslations } from 'next-intl';

import { Text } from '@hrworks/sui-core/Text';

import { SocialIcons } from '../SocialIcons';
import { S } from './Footer.styles';
import type { FooterProps } from './Footer.types';

export const Footer = ({ settings, ...otherProps }: FooterProps) => {
  const t = useTranslations('Footer');
  const hasSocialProfiles = Object.values(settings?.profiles ?? {}).some(Boolean);

  return (
    <>
      <Global styles={S.stickyBarGlobals} />
      <S.StickyBar data-guide-id="footer-container" $standalone={!hasSocialProfiles} {...otherProps}>
        <S.Inner>
          <S.Links>
            {settings?.privacyTermsUrl && (
              <S.FooterLink data-guide-id="footer-privacy-link" href={settings.privacyTermsUrl}>
                {t('privacy-policy')}
              </S.FooterLink>
            )}
            {settings?.privacyTermsUrl && settings?.imprintUrl && <S.Separator aria-hidden="true">|</S.Separator>}
            {settings?.imprintUrl && (
              <S.FooterLink data-guide-id="footer-imprint-link" href={settings.imprintUrl}>
                {t('imprint')}
              </S.FooterLink>
            )}
          </S.Links>
          <S.PoweredBy
            href="https://www.hrworks.de"
            target="_blank"
            rel="noopener noreferrer"
            data-guide-id="footer-powered-by"
          >
            <Text>{t('powered-by')}</Text>
          </S.PoweredBy>
        </S.Inner>
      </S.StickyBar>
      {hasSocialProfiles && (
        <S.SocialBar data-guide-id="footer-social-bar">
          <S.SocialInner>
            <S.Hr />
            <S.IconsRow>
              <SocialIcons profiles={settings?.profiles} />
            </S.IconsRow>
          </S.SocialInner>
        </S.SocialBar>
      )}
    </>
  );
};
